import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ThemePalette } from '@angular/material/core'
import { AbstractButtonComponent } from '../abstract-button/abstract-button.component'

@Component({
  selector: 'bdg-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent extends AbstractButtonComponent {
  @Input()
  matStyle: 'raised' | 'stroked' = 'stroked'
  @Input()
  matIcon: string
  @Input()
  label: string
  @Input()
  disabled: boolean
  @Input()
  color: ThemePalette = 'primary'
  @Input()
  type: 'button' | 'submit' = 'button'
  @Input()
  loading: boolean

  constructor() {
    super()
  }

  isDisabled() {
    return this.disabled || this.loading
  }

  hasStyle(style: string) {
    return this.matStyle === style
  }
}
